import { getSession } from './Crypto';

export const dataUserSession = () => {
    try {
        const dataUser = getSession("login")
        return dataUser;
    }
    catch (err) {
        return undefined
    }

}

export const ipAddressSession = () => {
    try {
        const ipaddress = getSession("ipAddress")
        return ipaddress;
    }
    catch (err) {
        return ''
    }

}

export const TokenSession = () => {
    try {
        const token = getSession("token")
        return token;
    }
    catch (err) {
        return undefined
    }

}

